import { render, staticRenderFns } from "./KabSupiori.vue?vue&type=template&id=0a7820b5"
import script from "./KabSupiori.vue?vue&type=script&lang=js"
export * from "./KabSupiori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports